import { Component } from 'react';
import { connect } from 'react-redux';

import { imageFile } from 'common/helpers/miscHelper';
import { currencyFormat } from 'common/helpers/numberHelper';
import {
  removeItemFromShipment,
  editItemOnShipment
} from 'redux/clubSubscriptionShipments/actions';

import ItemPrice from './ItemPrice';
import {
  totalItemsInShipmentWithoutItem,
  totalPriceInSubscriptionShipmentWithoutItem
} from './helpers';

class Item extends Component {
  constructor(props) {
    super(props);

    this.state = {
      quantity: props.item.quantity,
      error: null,
      isSubmitting: false
    };
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const { state } = this;
    if (newProps.item.quantity !== state.quantity) {
      this.setState({ quantity: newProps.item.quantity });
    }
  }

  submitForm = (e) => {
    e.preventDefault();
    this.setState({ isSubmitting: true });
    const { props, state } = this;
    const { clubSubscriptionShipment } = this.props;
    const { productVariantId } = props.item;
    const item = {
      quantity: Number(state.quantity)
    };
    const successFunction = () => {
      this.setState({ isSubmitting: false });
    };
    const errorFunction = () => {
      this.setState({ isSubmitting: false });
    };
    if (state.quantity === '') {
      this.setState({ error: 'Invalid Quantity', isSubmitting: false });
    } else {
      props.editItemOnShipment(
        clubSubscriptionShipment.id,
        productVariantId,
        item,
        successFunction,
        errorFunction
      );
    }
  };

  handleRemove = (e) => {
    e.preventDefault();
    this.setState({ isSubmitting: true });
    const { props } = this;
    const { clubSubscriptionShipment } = this.props;
    const { productVariantId } = props.item;
    const successFunction = () => {
      this.setState({ isSubmitting: false });
    };
    const errorFunction = () => {
      this.setState({ isSubmitting: false });
    };
    props.removeItemFromShipment(
      clubSubscriptionShipment.id,
      productVariantId,
      successFunction,
      errorFunction
    );
  };

  handleExchange = (e) => {
    e.preventDefault();
    const { props } = this;
    const { productVariantId } = props.item;
    props.onExchange(productVariantId);
  };

  handleQuantity = (e) => {
    const input = e.target.value;
    const quantity = input.replace(/[^0-9]/g, '');
    this.setState({ quantity, error: null });
  };

  render() {
    const { item, clubSubscriptionShipment, club, settings } = this.props;
    const { quantity, error, isSubmitting } = this.state;
    const totalItemsX = totalItemsInShipmentWithoutItem(
      clubSubscriptionShipment,
      item
    );
    const totalPriceX = totalPriceInSubscriptionShipmentWithoutItem(
      clubSubscriptionShipment,
      item
    );
    return (
      <div>
        <div className="c7-cart-items__quantity">
          {error && <span aria-describedby="qtyerror">{error}</span>}
          {renderUpdateForm(
            item,
            quantity,
            this.submitForm,
            this.handleQuantity,
            totalItemsX,
            totalPriceX,
            club,
            error,
            isSubmitting
          )}
        </div>
        <div className="c7-cart-items__image">
          <img
            src={imageFile(item.image, 'small')}
            alt={item.productVariantTitle}
          />
        </div>
        <div className="c7-cart-items__title">
          {item.productTitle}
          <div className="c7-cart-items__title__variant">
            {item.productVariantTitle}
          </div>
          {renderRemoveOrExchangeButton(
            item,
            this.handleRemove,
            this.handleExchange,
            totalItemsX,
            totalPriceX,
            club,
            isSubmitting
          )}
        </div>
        <ItemPrice item={item} settings={settings} />
        <div className="c7-cart-items__item-total">
          {currencyFormat(item.price * item.quantity, settings)}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  settings: state.setting
});

export default connect(mapStateToProps, {
  removeItemFromShipment,
  editItemOnShipment
})(Item);

const renderUpdateForm = (
  item,
  quantity,
  submitForm,
  handleQuantity,
  totalItemsX,
  totalPriceX,
  club,
  error,
  isSubmitting
) => {
  let { minQuantity, maxQuantity } = item;
  const { minQuantityInShipment } = club.subscription;
  if (
    minQuantityInShipment &&
    minQuantityInShipment - totalItemsX > minQuantity
  ) {
    minQuantity = minQuantityInShipment - totalItemsX;
  }
  const product = club.subscription.items.find(
    (pi) => pi.productVariantId === item.productVariantId
  );
  if (minQuantity < 1) {
    minQuantity = 1;
  }
  if (product && !product.isAvailableOnWeb) {
    maxQuantity = quantity;
  }

  if (maxQuantity && maxQuantity === minQuantity) {
    return <input name="quantity" type="text" value={quantity} readOnly />;
  }

  let describedby;
  if (error) {
    describedby = { 'aria-describedby': 'qtyerror' };
  }
  if (maxQuantity && maxQuantity - minQuantity < 12) {
    // Select Box
    const selectArray = [];
    for (let i = minQuantity; i <= maxQuantity; i += 1) {
      selectArray.push(i);
    }
    return (
      <form action="" onSubmit={submitForm} method="post">
        <select
          name="quantity"
          value={quantity}
          onChange={handleQuantity}
          aria-label={`Quantity for ${item.productTitle}`}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...describedby}
        >
          {selectArray.map((i) => (
            <option value={i} key={i}>
              {i}
            </option>
          ))}
        </select>
        <br />
        <button
          type="submit"
          className="c7-button-alt-small"
          disabled={isSubmitting}
        >
          Update
        </button>
      </form>
    );
  }
  return (
    <form action="" onSubmit={submitForm} method="post">
      <input
        name="quantity"
        type="text"
        value={quantity}
        onChange={handleQuantity}
        inputMode="numeric"
        aria-label={`Quantity for ${item.productTitle}`}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...describedby}
      />

      <br />
      <button
        type="submit"
        className="c7-button-alt-small"
        disabled={isSubmitting}
      >
        Update
      </button>
    </form>
  );
};

const renderRemoveOrExchangeButton = (
  item,
  handleRemove,
  handleExchange,
  totalItemsX,
  totalPriceX,
  club,
  isSubmitting
) => {
  if (item.minQuantity > 0) {
    return null;
  }
  const { minQuantityInShipment } = club.subscription;
  // Total items less clubPackage.minQuantity will be whether we can remove
  if (minQuantityInShipment) {
    if (totalItemsX < minQuantityInShipment) {
      return (
        <a
          href="#"
          onClick={handleExchange}
          aria-label={`Remove ${item.productTitle}`}
        >
          Exchange
        </a>
      );
    }
  }

  if (!isSubmitting) {
    return <a onClick={handleRemove}>Remove</a>;
  }
  return null;
};
